import { LuExpand } from 'react-icons/lu';
import { useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';

export interface InsightOpenDetailButtonProps {
    insightId: string;
    className?: string;
}

/** Top-left control that opens the insight detail page (does not make the whole card clickable). */
export const InsightOpenDetailButton = ({ insightId, className }: InsightOpenDetailButtonProps) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { formatMessage } = useIntl();

    const label = formatMessage({
        id: 'platform.analytics.insights.open-detail-button.aria-label',
        description: 'Accessible label for the button that opens an insight on a full-page detail view',
        defaultMessage: 'Open insight detail'
    });

    return (
        <button
            type='button'
            aria-label={label}
            title={label}
            className={`bg-background-default border-border-default text-brand-muted hover:bg-brand-light hover:text-brand-secondary relative flex size-9 shrink-0 cursor-pointer items-center justify-center rounded-md border ${className ?? ''}`}
            onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                navigate({ pathname: `/analytics/insights/${insightId}/detail`, search: location.search });
            }}>
            <LuExpand
                className='size-4'
                aria-hidden
            />
        </button>
    );
};
